import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'
import { prepareItem } from 'lib/checkout/userCart'
import { mapMultiCartAddItemaResponse } from './multiCartMappers'
import { arrayToObject } from 'lib/array/arrayUtils'

type AddItemsRequest = paths['/api/carts/multi-carts/{multiCartId}/items']['post']['parameters']['body']['payload']
type AddItemsResponse = paths['/api/carts/multi-carts/{multiCartId}/items']['post']['responses']['201']['content']['application/json']

export async function addItemsToMultiCart(cartId: string, items: Array<App.Checkout.AnyItem>): Promise<MachineContext.CartItems> {
  const preparedItems = items.map(prepareItem)

  // TODO: remove this and change the villas type check
  const payload = { items: preparedItems } as AddItemsRequest
  const multiCartItems = await request.post<AddItemsResponse, AddItemsRequest>(`/api/carts/multi-carts/${cartId}/items`, payload, { credentials: 'include' }).then(mapMultiCartAddItemaResponse)
  return { [cartId]: arrayToObject(multiCartItems, item => item.id) }
}
